import { PlanoSaudeProcedimento } from "./plano-saude-procedimento";

export class PlanoSaude {

    id: number = 0;

    nome: string = '';

    observacao: string = '';

    observacaoConsulta: string = '';

    ativo: boolean = true;

    interno: boolean = false;

    planoSaudeProcedimento: Array<PlanoSaudeProcedimento> = [];

    qtdDiasPeriodoVolta: number = 0;

    qtdAtdMes: number = 0;

    atdOutroMedicoPerVolta: boolean = false;

    indCobrarProcConsulta: boolean = false;

    ativoFormatado: string = '';

    internoFormatado: string = '';

    constructor() {
    }
}
